import Index from "pages/index"
import NotAuthorized from "pages/not-authorized"
import SaleOrders from "pages/sale-order/index"
import SaleOrderDetail from "pages/sale-order/details"
import Products from "pages/products/index"
import ProductDetail from "pages/products/details"
import Inventory from "pages/inventory/index"
import InboundDelivery from "pages/inbound-delivery/index"
import InboundDeliveryDetail from "pages/inbound-delivery/details"
import Return from "pages/return/index"
import BillOfMaterials from "pages/bom/index"
import BomDetail from "pages/bom/details"
import DGItemProfile from "pages/dg-item-profile"
import DGItemProfileDetail from "pages/dg-item-profile/details"
import FreightEnquiry from "pages/freight-enquiry"
import OutboundAnalytics from "pages/analytics/outbound"
import InboundAnalytics from "pages/analytics/inbound"

const routes = [
  { path: "/", exact: true, name: "index", title: "Home", component: Index },
  { path: "/not-authorized", exact: true, name: "not-authorized", title: "Not authorised", component: NotAuthorized },
  { path: "/sales-order", exact: true, name: "sales-order", title: "Sales orders", component: SaleOrders },
  { path: "/sales-order/:erpOrder/:id", exact: true, name: "sales-order-detail", title: "Sales order details", component: SaleOrderDetail },
  { path: "/products", exact: true, name: "products", title: "Products", component: Products },
  { path: "/products/:productId", exact: true, name: "products-detail", title: "Product details", component: ProductDetail },
  { path: "/inventory", exact: true, name: "inventory", title: "Inventory", component: Inventory },
  { path: "/inbound-delivery", exact: true, name: "inbound-delivery", title: "Inbound deliveries", component: InboundDelivery },
  { path: "/inbound-delivery/:receiptId/:id", exact: true, name: "inbound-delivery-detail", title: "Inbound delivery details", component: InboundDeliveryDetail },
  { path: "/return", exact: true, name: "return", title: "Returns", component: Return },
  { path: "/bom", exact: true, name: "bom", title: "Bills of materials", component: BillOfMaterials },
  { path: "/bom/:item", exact: true, name: "bom-detail", title: "Bill of materials details", component: BomDetail },
  { path: "/dg-item-profile", exact: true, name: "dg-item-profile", title: "DG item profiles", component: DGItemProfile },
  { path: "/dg-item-profile/:id/:item", exact: true, name: "dg-item-profile-detail", title: "DG item profile details", component: DGItemProfileDetail },
  { path: "/freight-enquiry", exact: true, name: "freight-enquiry", title: "Freight enquiry", component: FreightEnquiry },
  { path: "/analytics/outbound", exact: true, name: "analytics-outbound", title: "Outbound analytics", component: OutboundAnalytics },
  { path: "/analytics/inbound", exact: true, name: "analytics-inbound", title: "Inbound analytics", component: InboundAnalytics },
]

export default routes
